import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'
import './sass/override/app.scss'
import './plugins/defaultComponent'
import './plugins/axios'
import './plugins/currency'
import './plugins/cookie'
import i18n from './plugins/i18n'

import './mixins'

Vue.config.productionTip = false
Vue.config.silent = true

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
